import React, { useState } from "react";

const BackgroundInfoSection = ({
  languages,
  languages1,
  selected,
  setSelected,
  selected1,
  setSelected1,
  erfNumber,
  setErfNumber, // Add a setter for the ERF number
  onErfClick, // function to handle ERF button click (can open modal, prompt, etc in parent)
  onSave, // Callback for saving automatically when the number or ERF changes
  showError, // <-- NEW: parent can pass true to show error (section required)
}) => {
  const [error, setError] = useState("");
  const [landSizes, setLandSizes] = useState({}); // Store land sizes dynamically
  const [isErfFocused, setIsErfFocused] = useState(false); // Track if ERF input is focused

  // Show error if parent asks (on register click)
  React.useEffect(() => {
    if (showError) {
      setError(
        "This section is required. Please select at least one land type or enter ERF number."
      );
    }
  }, [showError]);

  // Optionally, clear error on any selection/change
  React.useEffect(() => {
    if (selected || selected1 || erfNumber) {
      setError("");
    }
  }, [selected, selected1, erfNumber]);

  const handleSizeChange = (lang, size) => {
    const updatedSizes = {
      ...landSizes,
      [lang]: size,
    };
    setLandSizes(updatedSizes);

    if (onSave) {
      onSave({ ...updatedSizes, erfNumber }); // Auto-save the updated sizes with ERF
    }
  };

  const handleErfChange = (e) => {
    const newErfNumber = e.target.value;
    setErfNumber(newErfNumber);

    if (onSave) {
      onSave({ ...landSizes, erfNumber: newErfNumber }); // Auto-save with updated ERF number
    }
  };

  return (
    <div>
      <div className="flex items-center justify-between">
        <h1 className="md:text-[36px] text-[10px] font-bold text-center mx-auto w-full">
          SECTION C: BACKGROUND INFORMATION
        </h1>
        <img
          src="https://res.cloudinary.com/dzngpgki4/image/upload/v1746297211/Expand_down_18_nrspje.png"
          alt="icon"
          className="md:w-[38px] md:h-[38px] w-[14px] h-[14px]"
        />
      </div>
      <div className="md:mt-6 mt-3">
        <h1 className="md:text-[32px] text-[8px] font-bold">
          Agricultural interest
        </h1>
        <p className="md:text-[24px] italic font-light text-[6px]">
          Enter / type the size of Land and click
        </p>
      </div>
      {(error || showError) && (
        <div className="text-red-600 text-xs mb-2">
          {error ||
            "This section is required. Please select at least one land type or enter ERF number."}
        </div>
      )}
      <div className="grid grid-cols-2 md:gap-2 gap-2 md:mt-2 mt-3">
        <div className="grid grid-cols-1 md:gap-4 gap-1">
          {languages.map((lang, i) => {
            const isActive = selected === lang;
            const isFoodGarden = lang.includes("Food garden allocation");
            const [mainLabel, subLabel] = isFoodGarden
              ? ["Community", "Food garden allocation"]
              : [lang, ""];
            return (
              <div key={i}>
                <button
                  onClick={() => setSelected(lang)}
                  disabled={lang === "-"}
                  className="flex items-center justify-between md:w-full  w-[170px] md:h-[72px] h-[30px] bg-[#E7EBEB] border border-[#E7EBEB] rounded-[5px] md:pr-4"
                >
                  <div className="bg-[#E7EBEB] md:h-[72px] h-[30px] w-[80px] md:w-[328px] text-left inline md:pt-3  justify-center md:pl-6  pl-1 leading-[1.10]">
                    <span className="font-medium md:text-[32px] text-[6px] leading-tight ">
                      {mainLabel}
                    </span>
                    {subLabel && (
                      <span className="font-normal md:text-[20px] text-[4px] md:pl-4 md:-mt-4 ">
                        {subLabel}
                      </span>
                    )}
                  </div>
                  <div className="flex md:space-x-12 space-x-2 items-center pr-2">
                    <input
                      type="number"
                      value={landSizes[lang] || "1"}
                      onChange={(e) => handleSizeChange(lang, e.target.value)}
                      className="bg-transparent text-white bg-[#E7EBEB]  md:text-[32px] text-[8px] outline-none border-none text-center font-medium underline md:w-16 w-8 focus:outline-none"
                    />
                    <h1 className="md:text-[32px] text-[8px] text-white font-medium">Ha</h1>
                  </div>
                  <span
                    className={`md:w-14 md:h-14 w-4 h-4 rounded-full 
                      ${
                        isActive
                          ? "bg-[#03897B] md:border-[8px] border-[3px] border-white"
                          : "md:border-[8px] border-[3px] border-white bg-transparent"
                      }`}
                  />
                </button>
              </div>
            );
          })}
        </div>
        <div>
          <div className="grid grid-cols-1 md:gap-[105px] gap-4">
            {languages1.map((lang, i) => {
              const isActive = selected1 === lang;
              let mainLabel = lang;
              let subLabel = "";
              if (lang.includes("vacant land")) {
                mainLabel = "Road side";
                subLabel = "vacant land";
              } else if (
                lang.includes("Local/ Tribunal Authority allocation")
              ) {
                mainLabel = "Village /";
                subLabel = "Local/ Tribunal Authority allocation";
              }
              return (
                <div key={i}>
                  <button
                    onClick={() => setSelected1(lang)}
                    disabled={lang === "-"}
                    className="flex items-center justify-between md:w-full  w-[170px] md:h-[72px] h-[30px] bg-[#E7EBEB] border border-[#E7EBEB] rounded-[5px] md:pr-4"
                  >
                    <div className="bg-[#E7EBEB] md:h-[72px] md:w-[328px] h-[30px] w-[80px] text-left inline md:pt-3 leading-[1.00] md:pl-6 pl-1">
                      <span className="font-medium md:text-[32px] text-[6px] leading-tight">
                        {mainLabel}
                      </span>
                      {subLabel && (
                        <span className="font-normal md:text-[20px] text-[4px] ">
                          {subLabel}
                        </span>
                      )}
                    </div>
                    <div className="flex md:space-x-12 space-x-2 items-center pr-2">
                      <input
                        type="number"
                        value={landSizes[lang] || "1"}
                        onChange={(e) => handleSizeChange(lang, e.target.value)}
                        className="bg-transparent text-white bg-[#E7EBEB]  md:text-[32px] text-[8px] outline-none border-none text-center font-medium underline md:w-16 w-8 focus:outline-none"
                      />
                      <h1 className="md:text-[32px] text-[8px] text-white font-medium">Ha</h1>
                    </div>
                    <span
                      className={`md:w-14 md:h-14 w-4 h-4 rounded-full 
                        ${
                          isActive
                            ? "bg-[#03897B] md:border-[8px] border-[3px] border-white"
                            : "md:border-[8px] border-[3px] border-white bg-transparent"
                        }`}
                    />
                  </button>
                </div>
              );
            })}
          </div>
          {/* ERF Number as a button with value from parent */}
          <button
            type="button"
            className="flex items-center justify-between md:mt-5 mt-8  w-[170px] md:w-full md:h-[72px] h-[30px] bg-[#152C24] border border-[#E7EBEB] rounded-[5px] md:pr-4"
            onClick={onErfClick}
          >
            <div className="bg-[#E7EBEB] md:h-[72px] h-[30px] w-[80px] md:w-[328px] text-left inline md:pt-3 pt-1 leading-[1.00] md:pl-6 pl-1">
              <span className="font-medium md:text-[32px] text-[8px] leading-tight">
                ERF Number
              </span>
            </div>
            <div className="flex md:space-x-12 space-x-2 items-center pr-2">
              <input
                type="text"
                value={erfNumber || ""}
                onChange={handleErfChange}
                onFocus={() => setIsErfFocused(true)} // Set focus state
                onBlur={() => setIsErfFocused(false)} // Reset focus state
                placeholder={!isErfFocused && !erfNumber ? "ERF1234" : ""} // Hide placeholder when focused or when there's a value
                className="bg-transparent text-white text-center placeholder:text-white  bg-[#152C24] border-[#152C24]  outline-transparent font-medium md:w-[200px] underline md:text-[32px] text-[8px] focus:outline-none"
              />
            </div>
            <span />
          </button>
        </div>
      </div>
    </div>
  );
};

export default BackgroundInfoSection;